import api from './api';

export interface SLA {
  _id?: string;
  name: string;
  description?: string;
  responseTime: number;
  resolutionTime: number;
  priorityMultipliers: {
    low: number;
    medium: number;
    high: number;
    critical: number;
  };
  isActive: boolean;
  createdBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

class SLAService {
  async createSLA(data: SLA): Promise<{ sla: SLA; message: string }> {
    const response = await api.post('/slas', data);
    return response.data;
  }

  async getSLAs(isActive?: boolean): Promise<SLA[]> {
    try {
      console.log('SLAService: Iniciando requisição getSLAs');
      
      // Verificar se o token de autenticação existe
      const token = localStorage.getItem('authToken');
      console.log('SLAService: Token de autenticação existe?', !!token);
      
      // Sempre fazer a requisição para o backend, independentemente do modo ou token
      // Isso garante que a requisição chegue ao backend para depuração
      
      // Se não estamos em modo de desenvolvimento, fazer a requisição real
      console.log('SLAService: Parâmetros:', isActive !== undefined ? { isActive } : {});
      const params = isActive !== undefined ? { isActive } : {};
      console.log('SLAService: URL da requisição:', '/slas');
      
      const response = await api.get('/slas', { params });
      console.log('SLAService: Resposta recebida:', response.status, response.data);
      
      return response.data;
    } catch (error: any) {
      console.error('SLAService: Erro na requisição getSLAs:', error.message);
      console.error('SLAService: Detalhes do erro:', error.response?.data || error);
      
      // Em caso de erro, retornar dados simulados para evitar quebrar a interface
      console.log('SLAService: Retornando dados simulados devido ao erro');
      return [
        {
          _id: '1',
          name: 'SLA Básico (Simulado)',
          description: 'Dados simulados devido a erro de conexão',
          responseTime: 24,
          resolutionTime: 72,
          priorityMultipliers: {
            low: 1,
            medium: 0.8,
            high: 0.6,
            critical: 0.4
          },
          isActive: true,
          createdAt: new Date(),
          updatedAt: new Date()
        }
      ];
    }
  }

  async getSLAById(id: string): Promise<SLA> {
    const response = await api.get(`/slas/${id}`);
    return response.data;
  }

  async updateSLA(id: string, data: Partial<SLA>): Promise<{ sla: SLA; message: string }> {
    if (!id) {
      throw new Error('ID do SLA não fornecido. Impossível atualizar.');
    }
    
    console.log(`Atualizando SLA com ID: ${id}`);
    console.log('Dados para atualização:', data);
    
    try {
      const response = await api.put(`/slas/${id}`, data);
      return response.data;
    } catch (error: any) {
      console.error(`Erro ao atualizar SLA ${id}:`, error.response?.data || error.message);
      throw error;
    }
  }

  async deleteSLA(id: string): Promise<{ sla: SLA; message: string }> {
    const response = await api.delete(`/slas/${id}`);
    return response.data;
  }
}

export default new SLAService();
